export const GET_TRANSLATIONS = 'rs00-language/rs01-get-translations';
export const GET_LIST_RESOURCE = 'si00-site/si04-get-resources';
